"use client";

import { RefreshRouteOnSave as PayloadLivePreview } from "@payloadcms/live-preview-react";
import { useRouter } from "next/navigation";

export function RefreshRouteOnSave() {
  const router = useRouter();

  if (typeof window === "undefined") {
    return null;
  }

  return <PayloadLivePreview refresh={() => router.refresh()} serverURL={window.location.origin} />;
}
